import React from 'react'

import './styles/TGPlayerHost.css'

export default function TGPlayerHost(props) {
  if (props && props !== undefined) {
    if (props.player === undefined) {
      console.log('undefined!!!!')
      console.log(props)
    }
    // console.log(props)
    const { username, eloRM, eloEW, color, civilization } = props.player
    // console.log(
    //   `username: ${username} | eloRM: ${eloRM} | eloEW: ${eloEW} | color: ${color} | civilization: ${civilization} # props: ${JSON.stringify(
    //     props
    //   )}`
    // )

    const backgroundColorPlayer = `linear-gradient(90deg,${color}cc 0%,${color}b3 90%, rgb(0 0 0 / 0%) 100%)`
    // console.log(backgroundColorPlayer)
    return (
      <article
        className='tg-host-player'
        style={{
          background: backgroundColorPlayer,
        }}
      >
        <div className='tg-host-player-row'>
          <h3>{username}</h3>
        </div>
        <div className='tg-host-player-row'>
          <div className='tg-host-player-column'>
            <img src={`./civs/${civilization}.png`} alt={civilization} />
          </div>
          <div className='tg-host-player-column'>
            <span>
              <b>RM:</b> {eloRM ? eloRM : '-'}
            </span>
            <span>
              <b>EW:</b> {eloEW ? eloEW : '-'}
            </span>
          </div>
        </div>
      </article>
    )
  } else {
    return ''
  }
}
